module.exports = __webpack_public_path__ + "static/media/20.da012267.svg";